import { useModal } from '../../../../../modal/useModal.hook';

export const useBoundaryEdit = () => {
  const { openModal } = useModal('BoundaryEdit');

  const startBoundaryEdit = (boundaryTerritoryGroupId: number) => {
    openModal({
      boundaryTerritoryGroupId,
    });
  };

  return {
    startBoundaryEdit,
  };
};
